import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedRole: {
        label: "Business growth (CEO)",
        value: "business-growth-ceo"
    },
    errors: {},
    isLLMModalOpen: false,
    selectedLLM: null,
}

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setSelectedRole: (state, action) => {
            const payload = action.payload;
            state.selectedRole = payload
        },
        setIsLLMModalOpen: (state, action) => {
            state.isLLMModalOpen = action.payload;
        },
        setSelectedLLM: (state, action) => {
            state.selectedLLM = action.payload;
        },
    },
});

export const { setSelectedRole, setIsLLMModalOpen, setSelectedLLM } = appSlice.actions;

export default appSlice.reducer;